
/**
 * The time, in milliseconds that the timer should wait
 * @param {*} delay The time, in milliseconds that the timer should wait
 * @returns 
 */
export async function timeout(delay: number): Promise<void> {
    return new Promise(res => setTimeout(res, delay));
}